export const getOrdinalSuffix = (day: number): string => {
  if (day > 3 && day < 21) return 'th';
  switch (day % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
};

export const truncateWithEllipsis = (text: string, maxLength = 160): string => {
  const trimmedText = text.trim();
  const ellipsis = '...';
  return trimmedText.length > maxLength
    ? trimmedText.substring(0, maxLength - ellipsis.length) + ellipsis
    : trimmedText;
};

export const compareStrings = (a: string, b: string): number => {
  return a.localeCompare(b, 'en-US', { sensitivity: 'base' });
};

export const isValidFilename = (f: unknown): f is string => {
  if (typeof f !== 'string') return false;
  const trimmed = f.trim();
  if (!trimmed) return false;
  if (trimmed.includes('..')) return false;
  if (trimmed.includes('\\')) return false;
  if (trimmed.startsWith('/')) return false;
  if (trimmed.length > 255) return false;
  return true;
};
